<template>
  <BContainer>
    <ReportFilter @apply="getScore">
      <template v-slot:customButtons>
        <b-tooltip
          class="control"
          :label="$t('description.sendReportDescription')"
          position="is-bottom"
          multilined
          type="is-light"
          v-if="isReportButtonActive"
        >
          <button class="button is-link" @click="sendReportToEmail">
            {{ $t('button.sendReport') }}
          </button>
        </b-tooltip>
      </template>
    </ReportFilter>
    <section style="padding-top:20px">
      <div v-if="data">
        <div
          class="columns"
          style="margin:20px 5px 10px 5px; background-color: hsl(0, 0%, 86%) !important;"
        >
          <div class="column">
            <div class="title is-size-5" style="margin-top:6px;">
              {{ processName }}
              {{ isGroup ? ' İç Denetim Skor Panosu' : 'Süreci İç Kontrol Skor Panosu' }}
            </div>
          </div>
        </div>
        <ScoreboardWithPoint :scoreGroup="data" v-if="isGroup" />
        <Scoreboard v-else :data="data" />
      </div>
    </section>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import ApiService from '../../_api/api.service'
import Scoreboard from './scoreboard/Scoreboard.vue'
import ScoreboardWithPoint from './ScoreboardWithPoint.vue'
import ReportFilter from './ReportFilter.vue'

export default {
  components: { Scoreboard, ScoreboardWithPoint, ReportFilter },
  data () {
    return {
      data: null,
      filter: {
        processId: null,
        answerSetId: null
      },
      isGroup: false,
      processName: '',
      answerSets: [],
      answerSetsByProcess: [],
      processes: [],
      isReportButtonActive: false
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'role'])
  },
  methods: {
    getScore (params, sendEmail) {
      const { filter, isGroup } = params
      this.isGroup = isGroup
      if (isGroup) {
        this.filter = filter
        this.processName = filter.content.processGroupName
        if (!sendEmail) sendEmail = false
        this.data = null
        const { answerSetGroupId, userId, processGroupId } = filter
        ApiService.post('/answerset/group/report', {
          answerSetGroupId,
          userId,
          processGroupId,
          website: this.$t('title.websiteName'),
          sendEmail,
          toEmail: this.role.admin ? this.currentUser.email : ''
        }).then(data => {
          this.isReportButtonActive = true
          if (sendEmail) {
            this.$buefy.toast.open({
              message: 'Rapor email adresinize gönderildi.',
              type: 'is-success'
            })
          }
          this.data = { ...data, processName: this.processName }
        })
      } else {
        this.processName = filter.content.processName
        this.filter = filter
        if (!sendEmail) sendEmail = false
        this.data = null
        const { answerSetId, userId, processId } = filter
        ApiService.post('/answerset/report', {
          answerSetId,
          userId,
          processId,
          website: this.$t('title.websiteName'),
          sendEmail,
          toEmail: this.role.admin ? this.currentUser.email : ''
        }).then(data => {
          this.isReportButtonActive = true
          if (sendEmail) {
            this.$buefy.toast.open({
              message: 'Rapor email adresinize gönderildi.',
              type: 'is-success'
            })
          }
          this.data = { ...data, processName: this.processName, answerSetId }
        })
      }
    },
    sendReportToEmail () {
      this.getScore({ filter: this.filter, isGroup: this.isGroup }, true)
    }
  }
}
</script>
